// import style from "./DataCollection.module.css"
import { useEffect, useState } from "react";
import {useDispatch,useSelector  } from "react-redux";
import Header from "../components/Header";

import VideoDetection from "../components/VideoDetection";
import DetectionResult from "../components/DetectionResult";
// import { useDetect } from "../contexts/DetectContext";
import LoadingOverlay from "../ui/LoadingOverlay";
import MoonLoader from "react-spinners/MoonLoader";
import {setDetectionImage,setInferenceTime,setUploadedImage,setIsDetecting} from "../features/detectSlice";

function DataCollection() {

  const dispatch = useDispatch();
  const { isLoading, message } = useSelector((state) => state.model);
  const [imageCount, setImageCount] = useState(0);
  const [activeButton, setActiveButton] = useState("Container");
  
  useEffect(() => {
    dispatch(setUploadedImage(null));
    dispatch(setDetectionImage(null));
    dispatch(setInferenceTime(0));
    dispatch(setIsDetecting(false));
  }, [dispatch]);
  return (
    <>
      <Header />
      <LoadingOverlay isVisible={isLoading} message={message}>
        <MoonLoader color="#00BFFF" size={50} />
      </LoadingOverlay>
      <div className="pageContent">
        <VideoDetection
          isCollecting={true}
          isDisplay={false}
          setImageCount={setImageCount}
          activeButton={activeButton}
          setActiveButton={setActiveButton}
        />
        <DetectionResult isDisplay={false} imageCount={imageCount} activeButton={activeButton}/>
      </div>
    </>
  );
}

export default DataCollection;
